import {
  createSlice,
  createEntityAdapter,
  createSelector,
} from '@reduxjs/toolkit'

import { apiSlice } from '../api/apiSlice'


console.info(apiSlice.endpoints)


// apiSlice.endpoints.getAssignmentMarks.initiate()
// apiSlice.endpoints.getQuizMarks.initiate()

const selectVideos = apiSlice.endpoints.getVideos.select()
const selectAssignments = apiSlice.endpoints.getAssignments.select()
const selectQuizzes = apiSlice.endpoints.getQuizzes.select()
// const selectAssignmentMarks = apiSlice.endpoints.getAssignmentMarks.select()
// const selectQuizMarks = apiSlice.endpoints.getQuizMarks.select()


export const selectCourseVideos = createSelector(
  [selectVideos, selectAssignments, selectQuizzes],
  (state, userId) => userId,
  (videos, assignments, quizzes, userId) => {
    console.info('videos====', videos)
    if (!videos?.data.length) return [];

    if (assignments?.data?.length) {
      videos?.data.forEach(video => {
        const assignment = assignments?.data.find(a => a.video_id == video.id);
        if (assignment) {
          video.assignment = assignment;
        }
      })
    }
    if (quizzes?.data?.length) {
      videos?.data.forEach(video => {
        const quiz = quizzes?.data.find(a => a.video_id == video.id);
        if (quiz) {
          video.quiz = quiz;
        }
      })
    }
    return videos;
  }
)

